module.exports = __webpack_public_path__ + "img/check-double.b8f23fa5.svg";